import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {
  NotificationService,
  LIST_SERVER_PAGINATION_INITIAL_STATE,
  ListServerPaginationStateModel,
  mapNullToNotAvailableValue,
  Error,
  CustomHttpErrorResponse,
} from '../../../../../../common';
import { HandlingUnitMaterial } from '../../../models';
import { HandlingUnitMaterials } from './handling-unit-materials.actions';
import { HandlingUnitMaterialsService } from './handling-unit-materials.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type HandlingUnitMaterialsStateModel = ListServerPaginationStateModel<HandlingUnitMaterial>;

const initialState: HandlingUnitMaterialsStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<HandlingUnitMaterialsStateModel>({
  name: 'handlingUnitHandlingList',
  defaults: initialState,
})
@Injectable()
export class HandlingUnitMaterialsState {
  constructor(
    private handlingUnitHandlingUnitsService: HandlingUnitMaterialsService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: HandlingUnitMaterialsStateModel): HandlingUnitMaterialsStateModel {
    return state;
  }

  @Selector()
  static getItems(state: HandlingUnitMaterialsStateModel): HandlingUnitMaterial[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: HandlingUnitMaterialsStateModel): boolean {
    return state.loaded;
  }

  @Action(HandlingUnitMaterials)
  getHandlingUnitMaterials(
    ctx: StateContext<HandlingUnitMaterialsStateModel>,
    { payload }: HandlingUnitMaterials,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.handlingUnitHandlingUnitsService
      .getHandlingUnits(payload.deliveryNoteNumber, payload.handlingUnitNumber, payload.searchCriteria)
      .pipe(
        take(1),
        map((handlingUnitMaterials: HandlingUnitMaterialsStateModel) => {
          ctx.patchState({
            ...handlingUnitMaterials,
            items: handlingUnitMaterials.items.map((item: HandlingUnitMaterial) =>
              mapNullToNotAvailableValue<HandlingUnitMaterial>(item),
            ),
            loaded: true,
          });
        }),
        catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
      );
  }
}
